import Cookies from 'js-cookie'
import analytics from 'utils/analytics'
 const userReducer = (state={authenticated:false, userData:{}}, action) => {
   switch (action.type) {
    case 'LOGIN':
      analytics.track("login")
      analytics.registerUser(action.payload.user)
      return {
        userData:action.payload.user,
        authenticated:true,
      }
    case 'LOGOUT':
      analytics.track("logout")
      Cookies.remove('stories_session')
      return {
        authenticated:false,
        userData:{}
      }
    case 'UPDATE_USER':
      analytics.registerUser(action.payload)
      return {
        userData:{...state.userData, ...action.payload},
        authenticated:true
      }
    case 'UPDATE_PROFILE':
      analytics.registerUser(action.payload)
      return {
        userData:action.payload,
        authenticated:true
      }
    default:
      return state
  }
}


export default userReducer;



// WEBPACK FOOTER //
// ./src/utils/reducers/user.js